document.addEventListener('DOMContentLoaded', () => {
    const toggle = document.getElementById('menu-toggle');
    const nav = document.getElementById('primary-navigation');

    if (!toggle || !nav) return;

    const siteHeader = document.getElementById('site-header');
    const adminBar = document.getElementById('wpadminbar');

    function updateNavTop() {
        const headerHeight = siteHeader ? (siteHeader.getBoundingClientRect().height || 0) : 0;
        const adminBarHeight = (adminBar && adminBar.offsetParent !== null)
            ? (adminBar.getBoundingClientRect().height || 0) : 0;
        document.documentElement.style.setProperty(
            '--site-header-actual-height',
            `${headerHeight + adminBarHeight}px`
        );
    }

    if (siteHeader && typeof ResizeObserver !== 'undefined') {
        const observer = new ResizeObserver(updateNavTop);
        observer.observe(siteHeader);
        if (adminBar) observer.observe(adminBar);
    }

    function syncBodyMenuOpen() {
        const mobileOpen = toggle.classList.contains('show') || nav.classList.contains('show');
        const dropdownOpen = nav.querySelector('.menu-item-has-children.is-open') !== null;
        document.body.classList.toggle('menu-open', mobileOpen || dropdownOpen);
    }

    function openMenu() {
        toggle.classList.add('show');
        toggle.setAttribute('aria-expanded', 'true');
        nav.classList.add('show');
        nav.setAttribute('aria-hidden', 'false');
        syncBodyMenuOpen();
    }

    function closeMenu() {
        toggle.classList.remove('show');
        toggle.setAttribute('aria-expanded', 'false');
        nav.classList.remove('show');
        nav.setAttribute('aria-hidden', 'true');
        syncBodyMenuOpen();
    }

    toggle.addEventListener('click', e => {
        e.preventDefault();
        toggle.classList.contains('show') ? closeMenu() : openMenu();
    });

    document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && toggle.classList.contains('show')) {
            closeMenu();
            toggle.focus();
        }
    });

    document.addEventListener('click', e => {
        if (!toggle.classList.contains('show')) return;
        if (!nav.contains(e.target) && e.target !== nav &&
            !toggle.contains(e.target) && e.target !== toggle) {
            closeMenu();
        }
    });

    toggle.setAttribute('aria-expanded', 'false');
    nav.setAttribute('aria-hidden', 'true');
    syncBodyMenuOpen();
});
